import React from 'react';
import { PALETTE, RUBY, FONT } from './tokens';
import type { ShellTheme } from './tokens';

export function ShellButton({ children, onClick, primary = false, theme }: {
  children: React.ReactNode; onClick: () => void; primary?: boolean; theme: ShellTheme;
}) {
  const p = PALETTE[theme];
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        minHeight: 48, padding: '0 20px', borderRadius: 12, border: 'none', cursor: 'pointer',
        font: `600 16px ${FONT}`, width: '100%',
        background: primary ? RUBY : p.quiet, color: primary ? '#FFFFFF' : p.ink,
      }}
    >
      {children}
    </button>
  );
}
